/*
 * Application Insights JavaScript SDK - Click Analytics, 2.6.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
/**
 * @copyright Microsoft 2020
 */
export var ActionType = {
    CLICKLEFT: 'CL',
    CLICKRIGHT: 'CR',
    CLICKMIDDLE: 'CM',
    SCROLL: 'S',
    ZOOM: 'Z',
    RESIZE: 'R',
    KEYBOARDENTER: 'KE',
    KEYBOARDSPACE: 'KS',
    OTHER: 'O'
};
//# sourceMappingURL=Enums.js.map